module.exports = __webpack_public_path__ + "static/img/map1_relation.0892ca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map1_relation.jpg
// module id = Puv/
// module chunks = 1